import {
  IMPORTATION_DETAILS_FILTER_MESSAGES,
  ImportationDetailsFiltersMessages,
} from "./importation-details-filter.messages";
import {
  IMPORTATION_DETAILS_REQUEST_MESSAGES,
  ImportationDetailsRequestMessages,
} from "./importation-details-request.messages";
import {
  IMPORTATION_DETAILS_TABLE_MESSAGES,
  ImportationDetailsTableMessages,
} from "./importation-details-table.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type ImportationDetailsMessages = ImportationDetailsFiltersMessages &
  ImportationDetailsTableMessages &
  SidebarMessages &
  ImportationDetailsRequestMessages &
  ActionButtonMessages & {
    importationDetailsPageTitle: string;
    importationDetailsBreadCrumbTitle: string;
    markAllAsReadButton: string;
    importPopover: string;
    importationDetailsErrorToLoad: string;
    importationDetailsNotFoundError: string;
    importationDetailsNotFoundDescription: string;
    importationDetailsNotFoundAlt: string;
    importationDetailsNotFoundAltFaktiu: string;
    breadCrumbTitle: string;
  };

export const IMPORTATION_DETAILS_MESSAGES: ImportationDetailsMessages = {
  importationDetailsPageTitle: "Detalhes da Importação",
  importationDetailsBreadCrumbTitle: "Detalhes da Importação",
  markAllAsReadButton: "Marcar todas como lidas",
  importPopover: "Ver Detalhes",
  importationDetailsErrorToLoad: "Erro ao carregar os detalhes da importação",
  importationDetailsNotFoundError: "Detalhes da importação não encontrados",
  importationDetailsNotFoundDescription: "Não foi possível encontrar os detalhes da importação.",
  importationDetailsNotFoundAlt: "Imagem alternativa para detalhes da importação não encontrada",
  importationDetailsNotFoundAltFaktiu:
    "Imagem alternativa (Faktiu) para detalhes da importação não encontrada",
  breadCrumbTitle: "Importações",

  ...SIDEBAR_MESSAGES,
  ...IMPORTATION_DETAILS_REQUEST_MESSAGES,
  ...IMPORTATION_DETAILS_FILTER_MESSAGES,
  ...IMPORTATION_DETAILS_TABLE_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
};

export default IMPORTATION_DETAILS_MESSAGES;
